"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var appraisal_1 = require("../../../shared/model/appraisal");
var equipment_1 = require("../../../shared/model/equipment");
var equipment_service_1 = require("../../../shared/service/equipment.service");
var equipment_model_service_1 = require("../../../shared/service/equipment-model.service");
var equipment_type_service_1 = require("../../../shared/service/equipment-type.service");
var appraisal_service_1 = require("../../service/appraisal.service");
var return_reason_1 = require("../../model/return-reason");
var equipment_model_1 = require("../../../shared/model/equipment-model");
var sim_card_1 = require("../../../shared/model/sim-card");
var access_1 = require("../../../shared/model/access");
var moment = require("moment");
var Subject_1 = require("rxjs/Subject");
var Observable_1 = require("rxjs/Observable");
var telecom_provider_1 = require("../../../shared/model/telecom-provider");
var router_1 = require("@angular/router");
var appraisal_test_service_1 = require("../../service/appraisal-test.service");
var date_pipe_1 = require("../../../shared/pipe/date.pipe");
var jira_ticket_service_1 = require("../../service/jira-ticket.service");
var platform_browser_1 = require("@angular/platform-browser");
var toast_service_1 = require("../../../shared/service/toast.service");
var AppraisalCreateUpdateComponent = /** @class */ (function () {
    function AppraisalCreateUpdateComponent(_equipmentService, _equipmentModelService, _equipmentTypeService, _appraisalService, _router, _route, _appraisalTestService, _jiraTicketService, _sanitizer, _toastService) {
        this._equipmentService = _equipmentService;
        this._equipmentModelService = _equipmentModelService;
        this._equipmentTypeService = _equipmentTypeService;
        this._appraisalService = _appraisalService;
        this._router = _router;
        this._route = _route;
        this._appraisalTestService = _appraisalTestService;
        this._jiraTicketService = _jiraTicketService;
        this._sanitizer = _sanitizer;
        this._toastService = _toastService;
        this.equipmentIdentifier = 'Serial';
        this.equipmentIdentifierAttribute = ['serial'];
        this.isTracker = true;
        this.invoiceNumberDisabled = true;
        this.editMode = false;
        this.setEmptyEntites();
        this.findEquipmentTypes();
        this.findReturnReasons();
        this.setPipes();
        this.editModeVerify();
        this.setUpObservers();
    }
    AppraisalCreateUpdateComponent.prototype.ngOnInit = function () {
    };
    AppraisalCreateUpdateComponent.prototype.setEmptyEntites = function () {
        this.newAppraisal = new appraisal_1.Appraisal();
        this.newAppraisal.reusable = false;
        this.newAppraisal.equipment = new equipment_1.Equipment();
        this.newAppraisal.equipment.equipmentModel = new equipment_model_1.EquipmentModel();
        this.newAppraisal.equipment.simCard = new sim_card_1.SimCard();
        this.newAppraisal.equipment.simCard.access = new access_1.Access();
        this.newAppraisal.equipment.simCard.telecomProvider = new telecom_provider_1.TelecomProvider();
        this.equipments = new Array();
        this.files = new Array();
        this.newAppraisal.files = new Array();
        this.ticketInput = new Subject_1.Subject();
        this.setAppraisalDate();
    };
    AppraisalCreateUpdateComponent.prototype.save = function () {
        if (this.setAppraisalTests()) {
            var files = this.assembleCorrectFilesList();
            if (!this.editMode) {
                this._appraisalService.save(this.newAppraisal, files);
            }
            else {
                this._appraisalService.update(this.newAppraisal, files);
            }
        }
        else {
            this.showMessage('É necessário selecionar pelo menos um resultado para cada item de teste.');
        }
    };
    AppraisalCreateUpdateComponent.prototype.goBack = function () {
        this._router.navigate(['appraisals', 'list']);
    };
    AppraisalCreateUpdateComponent.prototype.editModeVerify = function () {
        var _this = this;
        this._route.params.subscribe(function (params) {
            if (params['id']) {
                _this.editMode = true;
                _this.appraisalId = +params['id'];
                _this._appraisalService.findById(_this.appraisalId);
                _this._appraisalTestService.findAsMap(_this.appraisalId);
            }
        });
    };
    AppraisalCreateUpdateComponent.prototype.findEquipments = function (identifier) {
        if (this.isTracker) {
            this._equipmentService.findBySerial(identifier);
        }
        else {
            this._equipmentService.findByImei(identifier);
        }
    };
    AppraisalCreateUpdateComponent.prototype.findReturnReasons = function () {
        this._appraisalService.findReturnReasons();
    };
    AppraisalCreateUpdateComponent.prototype.findTestItems = function () {
        this._appraisalTestService.createAsMap(this.equipmentType);
    };
    AppraisalCreateUpdateComponent.prototype.findEquipmentTypes = function () {
        this._equipmentTypeService.findAll();
    };
    AppraisalCreateUpdateComponent.prototype.setUpObservers = function () {
        var _this = this;
        this.setUpTicketInputObserver();
        this._jiraTicketService.find$
            .subscribe(function (jiraTicket) {
            _this.newAppraisal.os = jiraTicket.os;
            _this.invoiceNumberDisabled = !!jiraTicket.invoiceNumber;
            _this.newAppraisal.invoiceNumber = jiraTicket.invoiceNumber;
            _this.newAppraisal.equipment = jiraTicket.equipment;
            _this.newAppraisal.entryDate = new Date(jiraTicket.created);
            if (jiraTicket.equipment) {
                _this.equipmentType = jiraTicket.equipment.equipmentModel.equipmentManufacturer.equipmentType;
            }
            _this.findTestItems();
        });
        this._jiraTicketService.error$
            .subscribe(function (error) {
            _this.appraisalTestsItems = null;
            _this.showMessage(error.text);
        });
        this._equipmentTypeService.find$
            .subscribe(function (equipmentTypes) { return _this.equipmentTypes = equipmentTypes; });
        this._appraisalService.find$
            .filter(function (reasons) { return reasons instanceof return_reason_1.ReturnReason; })
            .subscribe(function (reasons) { return _this.returnReasons = reasons; });
        this._equipmentModelService.find$
            .subscribe(function (models) { return _this.equipmentModels = models; });
        this._equipmentService.find$
            .subscribe(function (equipments) { return _this.equipments = equipments; });
        this._appraisalTestService.find$
            .subscribe(function (testItems) {
            _this.appraisalTestsItems = testItems;
            _this.handleEmptyTestItems();
        });
        this._appraisalService.save$
            .subscribe(function () { return _this._router.navigate(['appraisals', 'list']); });
        this._appraisalService.find$
            .filter(function (appraisal) { return appraisal instanceof appraisal_1.Appraisal; })
            .subscribe(function (appraisal) {
            _this.equipmentType = appraisal.equipment.equipmentModel.equipmentManufacturer.equipmentType;
            _this.newAppraisal = appraisal;
        });
        this._appraisalService.error$
            .subscribe(function (error) {
            _this.showMessage(error.text);
        });
    };
    AppraisalCreateUpdateComponent.prototype.fileChange = function (event) {
        var _this = this;
        var tempFiles = event.target.files;
        var _loop_1 = function (i) {
            var reader = new FileReader();
            reader.onload = function (otherEvent) {
                _this.files.push({ id: i, url: _this.sanitizeUrl(otherEvent.target.result), file: event.target.files[i] });
            };
            reader.readAsDataURL(event.target.files[i]);
        };
        for (var i = 0; i < tempFiles.length; i++) {
            _loop_1(i);
        }
    };
    AppraisalCreateUpdateComponent.prototype.sanitizeUrl = function (url) {
        return this._sanitizer.bypassSecurityTrustResourceUrl(url);
    };
    AppraisalCreateUpdateComponent.prototype.appraisalHasFiles = function () {
        return this.newAppraisal.files.find(function (file) { return !file.delete; });
    };
    AppraisalCreateUpdateComponent.prototype.removeFileFromInMemoryList = function (files, file) {
        var fileIndex = files.indexOf(file);
        files.splice(fileIndex, 1);
    };
    AppraisalCreateUpdateComponent.prototype.removeFileFromAppraisal = function (file) {
        var fileToDelete = this.newAppraisal.files.find(function (f) { return f.id === file.id; });
        fileToDelete.delete = true;
    };
    AppraisalCreateUpdateComponent.prototype.checkAsReusable = function () {
        this.newAppraisal.reusable = !this.newAppraisal.reusable;
    };
    AppraisalCreateUpdateComponent.prototype.checkTestItems = function (option, testItem) {
        if (option.result) {
            option.result = false;
        }
        else {
            if (option.appraisalTestTypeHasAppraisalTestItem.appraisalTestItem.name.toLowerCase() === 'normal') {
                this.deselectOptions(testItem);
            }
            else {
                this.deselectNormal(testItem);
            }
            option.result = true;
        }
    };
    AppraisalCreateUpdateComponent.prototype.getObjectKeys = function (object) {
        if (object) {
            return Object.keys(object);
        }
        return [];
    };
    AppraisalCreateUpdateComponent.prototype.setAppraisalDate = function () {
        if (!this.newAppraisal.appraisalDate) {
            this.newAppraisal.appraisalDate = new Date();
        }
    };
    AppraisalCreateUpdateComponent.prototype.getEquipmentEmptyListText = function () {
        return 'Digite o ' + this.equipmentIdentifier;
    };
    AppraisalCreateUpdateComponent.prototype.getTypedValue = function () {
        if (this.newAppraisal.equipment.serial || this.newAppraisal.equipment.imei) {
            if (this.isTracker) {
                return this.newAppraisal.equipment.serial;
            }
            else {
                return this.newAppraisal.equipment.imei;
            }
        }
        return '';
    };
    AppraisalCreateUpdateComponent.prototype.formatDate = function (date) {
        if (date) {
            return moment(date).format('DD/MM/YYYY HH:mm');
        }
        return null;
    };
    AppraisalCreateUpdateComponent.prototype.applyDateMask = function (event) {
        return this.datePipe.transform(event.target.value, event.key);
    };
    AppraisalCreateUpdateComponent.prototype.handleEmptyTestItems = function () {
        var _this = this;
        var notEmpty = Object.keys(this.appraisalTestsItems)
            .some(function (item) { return _this.appraisalTestsItems[item].length > 0; });
        if (!notEmpty) {
            this.findTestItems();
        }
    };
    AppraisalCreateUpdateComponent.prototype.setUpTicketInputObserver = function () {
        var _this = this;
        this.ticketInput
            .map(function (event) { return event.target.value; })
            .debounceTime(750)
            .distinctUntilChanged()
            .flatMap(function (search) { return Observable_1.Observable.of(search).delay(500); })
            .subscribe(function (typedValue) {
            if (typedValue && typedValue !== '') {
                _this.newAppraisal.os = null;
                _this.newAppraisal.invoiceNumber = null;
                _this.newAppraisal.equipment = new equipment_1.Equipment();
                _this._jiraTicketService.findJiraTicket(typedValue);
            }
        });
    };
    AppraisalCreateUpdateComponent.prototype.showMessage = function (message) {
        if (message) {
            this._toastService.showMessage(message, 4000);
        }
    };
    AppraisalCreateUpdateComponent.prototype.assembleCorrectFilesList = function () {
        var newFiles = new Array();
        this.files.forEach(function (file) {
            newFiles.push(file.file);
        });
        return newFiles;
    };
    AppraisalCreateUpdateComponent.prototype.deselectOptions = function (testItem) {
        this.appraisalTestsItems[testItem].forEach(function (option) {
            option.result = false;
        });
    };
    AppraisalCreateUpdateComponent.prototype.deselectNormal = function (testItem) {
        this.appraisalTestsItems[testItem].forEach(function (option) {
            if (option.appraisalTestTypeHasAppraisalTestItem.appraisalTestItem.name.toLowerCase() === 'normal') {
                option.result = false;
            }
        });
    };
    AppraisalCreateUpdateComponent.prototype.setAppraisalTests = function () {
        var isChecked = true;
        this.newAppraisal.appraisalTests = new Array();
        for (var _i = 0, _a = this.getObjectKeys(this.appraisalTestsItems); _i < _a.length; _i++) {
            var key = _a[_i];
            isChecked = this.validateTestItems(this.appraisalTestsItems[key]);
            if (isChecked) {
                this.newAppraisal.appraisalTests = this.newAppraisal.appraisalTests.concat(this.appraisalTestsItems[key]);
            }
            else {
                this.newAppraisal.appraisalTests = new Array();
                break;
            }
        }
        return isChecked;
    };
    AppraisalCreateUpdateComponent.prototype.setPipes = function () {
        this.datePipe = new date_pipe_1.DatePipe();
    };
    AppraisalCreateUpdateComponent.prototype.validateTestItems = function (testItems) {
        if (testItems && testItems.length > 0) {
            var isChecked_1 = false;
            testItems.forEach(function (item) {
                if (item.result) {
                    isChecked_1 = true;
                }
            });
            return isChecked_1;
        }
        return true;
    };
    AppraisalCreateUpdateComponent.ctorParameters = function () { return [{ type: equipment_service_1.EquipmentService }, { type: equipment_model_service_1.EquipmentModelService }, { type: equipment_type_service_1.EquipmentTypeService }, { type: appraisal_service_1.AppraisalService }, { type: router_1.Router }, { type: router_1.ActivatedRoute }, { type: appraisal_test_service_1.AppraisalTestService }, { type: jira_ticket_service_1.JiraTicketService }, { type: platform_browser_1.DomSanitizer }, { type: toast_service_1.ToastService }]; };
    return AppraisalCreateUpdateComponent;
}());
exports.AppraisalCreateUpdateComponent = AppraisalCreateUpdateComponent;
//# sourceMappingURL=appraisal-create-update.component.js.map


// WEBPACK FOOTER //
// appraisal-create-update.component.js